import {
  type AnalyticalFieldMappingFieldType,
  type InternalValue,
} from 'src/core/modules/bookkeep';

import { AnalyticalFieldMappingMaintenanceModal } from './AnalyticalFieldMappingMaintenanceModal';
import { AnalyticalFieldMappingSetupModal } from './AnalyticalFieldMappingSetupModal';
import { type AnalyticalFieldMappingData } from '../../hooks/useAnalyticalFieldMapping';

type Props<TField extends InternalValue, TValue extends InternalValue> = {
  internalField: TField;
  values: TValue[];
  isOpen: boolean;
  isSplittable: boolean;
  onClose: () => void;
  fieldType: AnalyticalFieldMappingFieldType;
  mapping: AnalyticalFieldMappingData<TValue>;
};

export const AnalyticalFieldMappingModalContainer = <
  TField extends InternalValue,
  TValue extends InternalValue,
>({
  mapping,
  ...rest
}: Props<TField, TValue>) => {
  switch (mapping.mappingState) {
    case 'setup':
      return <AnalyticalFieldMappingSetupModal {...mapping} {...rest} />;
    case 'maintenance':
      return <AnalyticalFieldMappingMaintenanceModal {...mapping} {...rest} />;
    default:
      return null;
  }
};
